import axios from "axios";
const token = window.localStorage.getItem("token");
const state = {
  socials: [],
};
const getters = {
  GetSocials: state => state.socials,
};
const actions = {
  async createSocial({ commit },payload) {
    let response = await axios.get('card/social',payload)
    commit('setSocialsData', response.data.data)
  },
  async deleteSocial({ commit },payload) {
    let response = await axios.post('card/social/delete',payload)
    commit('setSocialsData', response.data.data)
  },
};
const mutations = {
    setSocialsData(state, socialData) {
        state.socials = socialData;
      }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
